import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createSlots as _createSlots, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/icons/warnerror.svg'
import _imports_1 from '@/assets/icons/mailsent.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("h4", {
  class: "modal-title",
  id: "addusertitle"
}, "ADD NEW USER", -1)
const _hoisted_2 = {
  key: 0,
  class: "modalbody"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", {
  class: "circular",
  viewBox: "0 0 50 50"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    class: "path",
    cx: "25",
    cy: "25",
    r: "20",
    fill: "none"
  })
], -1)
const _hoisted_4 = { class: "fieldLength" }
const _hoisted_5 = { class: "fieldLength" }
const _hoisted_6 = { class: "fieldLength" }
const _hoisted_7 = {
  key: 0,
  class: "errordiv emailerror"
}
const _hoisted_8 = {
  key: 1,
  class: "errordiv"
}
const _hoisted_9 = {
  key: 2,
  class: "maxitemsdiv errordiv"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "warnimagestyle",
  alt: "warnimg",
  title: "warnimg"
}, null, -1)
const _hoisted_11 = { style: {"padding":"1rem 0"} }
const _hoisted_12 = { class: "buttonsdiv" }
const _hoisted_13 = {
  key: 0,
  class: "fa fa-refresh fa-spin"
}
const _hoisted_14 = {
  key: 0,
  class: "fa fa-refresh fa-spin"
}
const _hoisted_15 = {
  key: 1,
  class: "modalbody"
}
const _hoisted_16 = { class: "labeldiv" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  style: {"width":"70px","margin-bottom":"1rem"},
  alt: "mailsentimg",
  title: "mailsentimg"
}, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "labelbld" }, "Notification email sent to: ", -1)
const _hoisted_19 = { class: "labelfont" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = { class: "buttonsdiv" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_select_v2 = _resolveComponent("el-select-v2")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_AddCSVFileModal = _resolveComponent("AddCSVFileModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    (_ctx.taskType === 'add')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _createVNode(_component_el_form, {
              "label-width": "auto",
              "label-position": "top",
              size: "default"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "Company",
                  class: "firstLetterCapital"
                }, {
                  default: _withCtx(() => [
                    (!_ctx.showUserCompany)
                      ? (_openBlock(), _createBlock(_component_el_select_v2, {
                          key: 0,
                          ref: "select",
                          options: _ctx.compOptions,
                          id: "usercompanyselect",
                          modelValue: _ctx.companyInfo,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.companyInfo) = $event)),
                          "value-key": "companyBucketId",
                          class: "user-inputstyle",
                          placeholder: "Select Company",
                          remote: "",
                          loading: _ctx.loading,
                          size: "large"
                        }, _createSlots({
                          loading: _withCtx(() => [
                            _hoisted_3
                          ]),
                          _: 2
                        }, [
                          (_ctx.showLoadCompanies)
                            ? {
                                name: "footer",
                                fn: _withCtx(() => [
                                  _createVNode(_component_el_button, {
                                    text: "",
                                    bg: "",
                                    size: "small",
                                    onClick: _ctx.fetchCompanies
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Load more companies ")
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"])
                                ]),
                                key: "0"
                              }
                            : undefined
                        ]), 1032, ["options", "modelValue", "loading"]))
                      : _createCommentVNode("", true),
                    (_ctx.showUserCompany)
                      ? (_openBlock(), _createBlock(_component_el_select, {
                          key: 1,
                          id: "selectedusercompany",
                          modelValue: _ctx.selectedCompany,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedCompany) = $event)),
                          class: "user-inputstyle",
                          size: "large",
                          disabled: ""
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.companyData, (item, index) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: index,
                                label: item.companyName,
                                value: item.companyValue
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "First Name",
                  class: "firstLetterCapital"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      id: "userfirstname",
                      required: "",
                      modelValue: _ctx.inviteData.firstName,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.inviteData.firstName) = $event)),
                      placeholder: "First Name",
                      maxlength: _ctx.maxNameLength,
                      class: "user-inputstyle"
                    }, null, 8, ["modelValue", "maxlength"]),
                    _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.maxNameLength - _ctx.inviteData.firstName.length) + " / " + _toDisplayString(_ctx.maxNameLength), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "Last Name",
                  class: "firstLetterCapital"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      id: "userlastname",
                      required: "",
                      modelValue: _ctx.inviteData.lastName,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.inviteData.lastName) = $event)),
                      placeholder: "Last Name",
                      maxlength: _ctx.maxNameLength,
                      class: "user-inputstyle"
                    }, null, 8, ["modelValue", "maxlength"]),
                    _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.maxNameLength - _ctx.inviteData.lastName.length) + " / " + _toDisplayString(_ctx.maxNameLength), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "Email address",
                  class: "firstLetterCapital"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      id: "useremail",
                      required: "",
                      modelValue: _ctx.inviteData.email,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.inviteData.email) = $event)),
                      placeholder: "Enter Email",
                      maxlength: _ctx.maxEmailLength,
                      class: "user-inputstyle"
                    }, null, 8, ["modelValue", "maxlength"]),
                    _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.maxEmailLength - _ctx.inviteData.email.length) + " / " + _toDisplayString(_ctx.maxEmailLength), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              id: "csvfilebutton",
              round: "",
              class: "csvbuttonstyle",
              variant: "outline-dark",
              onClick: _ctx.browseCSVFileHandler,
              disabled: _ctx.company === null,
              title: "Select a company to add users."
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Add multiple users with CSV file ")
              ]),
              _: 1
            }, 8, ["onClick", "disabled"])
          ]),
          (_ctx.noemail)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, " Please enter the valid email address "))
            : _createCommentVNode("", true),
          (_ctx.hasError)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, "All the fields are required!"))
            : _createCommentVNode("", true),
          (_ctx.showError && _ctx.addUserError !== '')
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.addUserError), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_12, [
            (_ctx.taskType === 'add' && !_ctx.showUserCompany)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  id: "adduserbutton",
                  round: "",
                  class: "btnstyle ml-4",
                  variant: "warning",
                  onClick: _ctx.AddUserInvite,
                  title: "Select a company to add users.",
                  disabled: !_ctx.enableControls || _ctx.company === null
                }, {
                  default: _withCtx(() => [
                    (!_ctx.enableControls && !_ctx.showError)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_13))
                      : _createCommentVNode("", true),
                    _createTextVNode(" Send Invite ")
                  ]),
                  _: 1
                }, 8, ["onClick", "disabled"]))
              : _createCommentVNode("", true),
            (_ctx.taskType === 'add' && _ctx.showUserCompany)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 1,
                  id: "addcompanyuserbutton",
                  round: "",
                  class: "btnstyle ml-4",
                  variant: "warning",
                  onClick: _ctx.AddUserInvite,
                  disabled: !_ctx.enableControls || !_ctx.showUserCompany
                }, {
                  default: _withCtx(() => [
                    (!_ctx.enableControls && !_ctx.showError)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_14))
                      : _createCommentVNode("", true),
                    _createTextVNode(" Send Invite ")
                  ]),
                  _: 1
                }, 8, ["onClick", "disabled"]))
              : _createCommentVNode("", true),
            _createVNode(_component_el_button, {
              id: "usercancel",
              round: "",
              variant: "outline-dark",
              onClick: _ctx.cancelInvite,
              class: "cancelbtn"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Cancel ")
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_AddCSVFileModal, {
      cancelInvite: _ctx.cancelInvite,
      companyData: _ctx.company
    }, null, 8, ["cancelInvite", "companyData"]),
    (_ctx.taskType === 'emailSent')
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _hoisted_18,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notifiedUsers, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                style: {"display":"flex"}
              }, [
                _createElementVNode("p", _hoisted_19, [
                  _createElementVNode("strong", null, _toDisplayString(item.name), 1),
                  _createTextVNode(" "),
                  _hoisted_20,
                  _createTextVNode(" (" + _toDisplayString(item.email) + " ) ", 1)
                ])
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createVNode(_component_el_button, {
              id: "adduserdone",
              round: "",
              class: "btnstyle",
              variant: "warning",
              onClick: _ctx.cancelInvite,
              style: {"float":"right"}
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Done ")
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}